import React, { FC } from "react";
import { useTheme } from "@mui/material/styles";

const DDBIcon: FC = () => {
  const theme = useTheme();
  return (
    <svg
      data-testid="ddb-icon"
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.7083 12.1667V7.79167H7.29167V12.1667H13.125C13.125 13.327 13.5859 14.4398 14.4064 15.2603C15.2269 16.0807 16.3397 16.5417 17.5 16.5417C18.6603 16.5417 19.7731 16.0807 20.5936 15.2603C21.4141 14.4398 21.875 13.327 21.875 12.1667H27.7083ZM27.7083 4.875C28.4819 4.875 29.2237 5.18229 29.7707 5.72927C30.3177 6.27625 30.625 7.01812 30.625 7.79167V18C30.625 18.7735 30.3177 19.5154 29.7707 20.0624C29.2237 20.6094 28.4819 20.9167 27.7083 20.9167H7.29167C6.51812 20.9167 5.77625 20.6094 5.22927 20.0624C4.68229 19.5154 4.375 18.7735 4.375 18V7.79167C4.375 7.01812 4.68229 6.27625 5.22927 5.72927C5.77625 5.18229 6.51812 4.875 7.29167 4.875H27.7083ZM4.375 22.375H13.125C13.125 23.5353 13.5859 24.6481 14.4064 25.4686C15.2269 26.2891 16.3397 26.75 17.5 26.75C18.6603 26.75 19.7731 26.2891 20.5936 25.4686C21.4141 24.6481 21.875 23.5353 21.875 22.375H30.625V28.2083C30.625 28.9819 30.3177 29.7237 29.7707 30.2707C29.2237 30.8177 28.4819 31.125 27.7083 31.125H7.29167C6.51812 31.125 5.77625 30.8177 5.22927 30.2707C4.68229 29.7237 4.375 28.9819 4.375 28.2083V22.375Z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};

export default DDBIcon;
